enum BeneficiaryServicesColumnsEnum {
  WALLET_NUMBER = 'WalletNumber',
  FULL_NAME = 'FullName',
  CPF = 'CPF',
  BIRTH_DATE = 'BirthDate',
  TYPE = 'Type',
  PLAN = 'Plan',
  STATUS = 'Status',
  ACTIONS = 'Actions',
}

const BeneficiaryServicesColumns = [
  {
    id: 1,
    label: 'Nº carteirinha',
    name: BeneficiaryServicesColumnsEnum.WALLET_NUMBER,
    sortable: false,
  },
  {
    id: 2,
    label: 'Nome completo',
    name: BeneficiaryServicesColumnsEnum.FULL_NAME,
    sortable: false,
  },
  {
    id: 3,
    label: 'CPF',
    name: BeneficiaryServicesColumnsEnum.CPF,
    sortable: false,
  },
  {
    id: 4,
    label: 'Nasc.',
    name: BeneficiaryServicesColumnsEnum.BIRTH_DATE,
    sortable: false,
  },
  {
    id: 5,
    label: 'Titularidade',
    name: BeneficiaryServicesColumnsEnum.TYPE,
    sortable: false,
  },
  {
    id: 6,
    label: 'Plano',
    name: BeneficiaryServicesColumnsEnum.PLAN,
    sortable: false,
  },
  {
    id: 7,
    label: 'Status',
    name: BeneficiaryServicesColumnsEnum.STATUS,
    sortable: false,
  },
  {
    id: 8,
    label: '',
    name: BeneficiaryServicesColumnsEnum.ACTIONS,
    sortable: false,
  },
];

export { BeneficiaryServicesColumnsEnum, BeneficiaryServicesColumns };
